const UnAuthorized = () => {
    return (
        <div>
            <h1 className="text-center txt-4xl mt-48">
                YOU ARE UNAUTHORIZED! (^_^)
            </h1>
        </div>
    );
};

export default UnAuthorized;
